<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <form class="form-horizontal" @submit.prevent="onSubmit">
          <card class="text-left">
            <template slot="header">
              <h4 class="card-title">스케줄 일정 등록</h4>
            </template>
            <div>
              <div class="row">
                <label class="col-sm-2 col-form-label">타입</label>
                <div class="col-sm-10 checkbox-radios">
                  <span v-for="(n, index) in scheduleTypes" :key="index">
                    <base-radio :name="n.id.toString()" inline v-model="scheduleType">{{ n.name }}</base-radio>
                  </span>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">알림 타입</label>
                <div class="col-sm-4">
                  <el-select multiple class="select-primary" size="large" placeholder="알림타입" v-model="scheduleNotificationTypes.typeIds">
                    <el-option
                      v-for="option in scheduleNotificationTypes.options"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-sm-4">
                  {{ scheduleNotificationTimes.toString() }}
                </div>
                <div v-if="scheduleId" class="col-sm-1">
                  <base-button @click="sendNotification" type="success">즉시발송</base-button>
                </div>
              </div>

              <div class="row" v-if="selectedScheduleMetadataTypes.length > 0">
                <label class="col-sm-2 col-form-label">메타데이터</label>
                <div class="col-sm-4">
                  <el-select class="select-primary" size="large" placeholder="메타데이터" v-model="scheduleMetadataType">
                    <el-option
                      v-for="option in selectedScheduleMetadataTypes"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="option.name"
                    ></el-option>
                  </el-select>
                </div>
                <div v-if="selectedScheduleMetadataType.hasLocation === 1" class="col-sm-4">
                  <v-select
                    class="select-primary"
                    size="large"
                    placeholder="국가선택"
                    :clearable="false"
                    :options="countryCodes"
                    label="name"
                    :reduce="(label) => label.isoCode"
                    v-model="countryCode"
                  >
                  </v-select>
                  <v-select
                    class="select-primary"
                    size="large"
                    placeholder="도시선택"
                    :clearable="false"
                    :options="cities"
                    label="name"
                    :reduce="(label) => label.name"
                    v-model="city"
                  >
                  </v-select>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">타이틀</label>
                <div class="col-sm-10">
                  <base-input placeholder="타이틀" v-model="title" required>
                    <span slot="helpBlock" class="form-text"></span>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">템플릿</label>
                <div class="col-sm-10">
                  <TemplateSelect type="schedule" @templateApply="applyTemplate"></TemplateSelect>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">내용</label>
                <div class="col-sm-10">
                  <base-input placeholder="내용">
                    <textarea class="form-control" id="content" rows="10" v-model="content"></textarea>
                  </base-input>
                </div>
              </div>

              <div>
                <div class="row">
                  <label class="col-sm-2 col-form-label">컨텐츠추가</label>

                  <base-button @click="addContent" type="success">+</base-button>
                </div>
                <draggable class="row" v-model="contents" group="people" @start="drag = true" @end="drag = false">
                  <div class="col-sm-12" v-for="(content, index) in contents">
                    <div class="row">
                      <div class="col-sm-2">
                        <span v-for="(n, i) in contentTypes" :key="i">
                          <base-radio @change="onChangeContentType(index)" :name="n.type" inline v-model="content.contentType">{{ n.name }}</base-radio>
                        </span>
                      </div>

                      <div v-if="content.contentType === 'I'" class="col-sm-8">
                        <div class="row">
                          <div class="col-sm-4">
                            <BlipFileUploadZone
                              :upload-category="7"
                              :index="index"
                              :maxFiles="1"
                              :fileUrl="content.imageUrl"
                              @onChangeFileIds="onMediaFileIdChange"
                            />
                          </div>
                          <div class="col-sm-3">
                            <label class="col-sm-2 col-form-label">이미지 비율</label>
                            <div class="col-sm-10">
                              <el-select class="select-primary" size="large" placeholder="이미지비율" @change="onRatioChange(content)" v-model="content.ratio">
                                <el-option
                                  v-for="option in ratios"
                                  class="select-primary"
                                  :value="option.value"
                                  :label="option.label"
                                  :key="option.label"
                                ></el-option>
                              </el-select>
                            </div>
                          </div>
                          <div v-if="content.imageUrl && content.ratio" class="col-sm-4">
                            <label class="col-sm-2 col-form-label">표시영역</label>
                            <div class="col-sm-10">
                              <cropper
                                :ref="'cropper' + index"
                                classname="cropper"
                                :src="content.imageUrl"
                                :stencilProps="{
                                  aspectRatio: content.aspectRatio,
                                }"
                                :canvas="false"
                                @change="onCropperChange"
                              ></cropper>
                              <base-button @click="cropImage(content.imageFileId, index)"> 적용 </base-button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-8" v-if="content.contentType === 'V'">
                        <div class="row">
                          <div class="col-sm-6">
                            <BlipFileUploadZone
                              :upload-category="7"
                              :index="index"
                              :maxFiles="1"
                              :fileUrl="content.imageUrl"
                              @onChangeFileIds="onMediaFileIdChange"
                            />
                          </div>
                          <div class="col-sm-6">
                            <div class="row">
                              <label class="col-sm-2 col-form-label">URL</label>
                              <div class="col-sm-10">
                                <base-input placeholder="url" v-model="content.path">
                                  <span slot="helpBlock" class="form-text" />
                                </base-input>
                              </div>
                            </div>
                            <div class="row">
                              <label class="col-sm-2 col-form-label"></label>
                              <div class="col-sm-10">
                                <base-button @click="getMetadata(content.path, index)" type="default">썸네일불러오기</base-button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-sm-1 col-form-label">타이틀</label>
                          <div class="col-sm-3">
                            <base-input placeholder="타이틀" v-model="content.title">
                              <span slot="helpBlock" class="form-text" />
                            </base-input>
                          </div>
                          <label class="col-sm-1 col-form-label">서브타이틀</label>
                          <div class="col-sm-3">
                            <base-input placeholder="서브타이틀" v-model="content.subtitle">
                              <span slot="helpBlock" class="form-text" />
                            </base-input>
                          </div>
                          <label class="col-sm-1 col-form-label">재생시간(초)</label>
                          <div class="col-sm-3">
                            <base-input placeholder="재생시간" v-model="content.duration">
                              <span slot="helpBlock" class="form-text" />
                            </base-input>
                          </div>
                          <label v-if="selectedScheduleMetadataType.hasArtist === 1" class="col-sm-1 col-form-label">관련멤버</label>
                          <div v-if="selectedScheduleMetadataType.hasArtist === 1" class="col-sm-3">
                            <el-select class="select-primary" size="large" placeholder="관련멤버" v-model="content.artistId">
                              <el-option class="select-primary" :value="null" label="없음"></el-option>
                              <el-option
                                v-for="option in members"
                                class="select-primary"
                                :value="option.id"
                                :label="option.name"
                                :key="option.name"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>

                      <div v-if="content.contentType === 'T'" class="col-sm-8">
                        <label class="col-sm-2 col-form-label">내용</label>
                        <el-popover trigger="hover" placement="top">
                          <div>
                            <div class="popover-body">
                              [링크텍스트](링크URL) 입력시, 링크텍스트에 하이퍼링크가 적용됩니다<br />
                              ex) [블립](https://www.blip.kr) 입력시, 블립에 하이퍼링크 적용
                            </div>
                          </div>
                          <base-button slot="reference"> ? </base-button>
                        </el-popover>
                        <base-input placeholder="내용">
                          <textarea class="form-control" rows="10" v-model="content.description"></textarea>
                        </base-input>
                      </div>

                      <base-button @click="removeContent(index)" type="default">-</base-button>
                    </div>
                    <div class="row">&nbsp;</div>
                  </div>
                </draggable>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">위치</label>
                <div class="col-sm-2">
                  <el-select class="select-primary" size="large" placeholder="위치" v-model="location.type">
                    <el-option
                      v-for="option in location.options"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </div>
                <div v-if="location.type !== null" class="col-sm-8">
                  <base-input placeholder="위치" v-model="location.name">
                    <span slot="helpBlock" class="form-text"></span>
                  </base-input>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">참여멤버</label>
                <div class="col-sm-10 checkbox-radios">
                  <span v-for="(n, index) in members" :key="index">
                    <base-checkbox v-model="members[index].value" inline>{{ n.name }}</base-checkbox>
                  </span>
                </div>
              </div>
              <div v-if="!scheduleId" class="row">
                <label class="col-sm-2 col-form-label">다른 아티스트</label>
                <div class="col-sm-10 checkbox-radios">
                  <collapse>
                    <collapse-item title="아티스트 선택" class="text-left">
                      <span v-for="(n, index) in units" :key="index">
                        <base-checkbox v-model="units[index].value" inline>{{ n.blipName }}</base-checkbox>
                      </span>
                    </collapse-item>
                  </collapse>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">노출여부</label>
                <div class="col-sm-4">
                  <base-switch v-model="isShow" type="primary" on-text="ON" off-text="OFF"></base-switch>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">하루종일</label>
                <div class="col-sm-4">
                  <base-switch v-model="isAllday" type="primary" on-text="ON" off-text="OFF"></base-switch>
                </div>
                <label class="col-sm-2 col-form-label">종료시간숨김</label>
                <div class="col-sm-4">
                  <base-switch v-model="isEndTimeHidden" type="primary" on-text="ON" off-text="OFF"></base-switch>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">시작시간</label>
                <div class="col-sm-4">
                  <base-input v-if="isAllday">
                    <el-date-picker type="date" placeholder="시작시간" v-model="startTime"></el-date-picker>
                  </base-input>
                  <base-input v-else>
                    <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
                  </base-input>
                </div>

                <label class="col-sm-2 col-form-label">종료시간</label>
                <div class="col-sm-4">
                  <base-input v-if="isAllday">
                    <el-date-picker type="date" placeholder="종료시간" v-model="endTime"></el-date-picker>
                  </base-input>
                  <base-input v-else>
                    <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
                  </base-input>
                </div>

                <label class="col-sm-2 col-form-label">스케줄오픈시간</label>
                <div class="col-sm-4">
                  <base-input>
                    <el-date-picker type="datetime" placeholder="오픈시간" v-model="openTime"></el-date-picker>
                  </base-input>
                </div>
                <label class="col-sm-2 col-form-label">등록시간</label>
                <div class="col-sm-4 col-form-label">{{ regTime | formatDateTime }}</div>
              </div>
            </div>

            <div class="row">
              <label class="col-sm-2 col-form-label">반복여부</label>
              <div class="col-sm-4">
                <el-select class="select-primary" size="large" placeholder="반복선택" v-model="repeat.repeatId">
                  <el-option
                    v-for="option in repeat.options"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </el-select>
              </div>

              <label v-if="repeat.repeatId" class="col-sm-2 col-form-label">반복기간</label>
              <div v-if="repeat.repeatId" class="col-sm-4">
                <base-input>
                  <el-date-picker type="date" placeholder="반복시작" v-model="repeat.repeatStartDate"></el-date-picker>
                </base-input>
                <base-input>
                  <el-date-picker type="date" placeholder="반복종료" v-model="repeat.repeatEndDate"></el-date-picker>
                </base-input>
              </div>
              <label class="col-sm-2 col-form-label">수정시간</label>
              <div class="col-sm-4 col-form-label">{{ modTime | formatDateTime }}</div>
            </div>
            <div v-if="repeat.repeatId && scheduleId" class="row">
              <label class="col-sm-2 col-form-label">일괄적용</label>
              <div class="col-sm-4">
                <base-switch v-model="isSaveAll" type="primary" on-text="ON" off-text="OFF"></base-switch>
                <el-popover trigger="hover" placement="top">
                  <div>
                    <div class="popover-body">
                      반복 수정시에는 일괄 적용을 선택해야 반복이 적용됩니다<br />일괄적용 OFF : 반복스케줄일때 하나의 스케줄만 빼서 적용한다(반복에서 분리)
                      <br />일괄적용 ON : 해당기간안에 있는 스케줄을 반복해서 적용한다
                    </div>
                  </div>
                  <base-button slot="reference"> ? </base-button>
                </el-popover>
              </div>
            </div>
          </card>
          <div v-if="scheduleId">
            <FanLogTableView :schedule-id="scheduleId"></FanLogTableView>
          </div>
          <div v-if="!isDeleted">
            <base-button native-type="submit" type="success" :disabled="buttonDisabled">등록</base-button>
            <base-button @click="deleteSchedule" type="danger">삭제</base-button>
            <base-button @click="deleteAllSchedule" type="danger">연관스케줄삭제</base-button>
            <base-button @click="goBack" type="default">뒤로</base-button>
          </div>
        </form>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>
<script>
import TemplateSelect from "@/pages/Components/TemplateSelect.vue";
import { TemplateLocation } from "@/pages/Components/TemplateSelect.vue";
import { BaseButton, BaseInput, BaseSwitch, Card, Collapse, CollapseItem } from "@/components/index";
import { Cropper } from "vue-advanced-cropper";

import * as moment from "moment";

import { Toast } from "@/util/Toast";

import BlipFileUploadZone from "@/components/BlipFileUploadZone";

import draggable from "vuedraggable";
import { formatDateTime } from "@/util/DateUtils";
import * as _ from "lodash";
import FanLogTableView from "./FanLogTableView.vue";

export default {
  components: {
    TemplateSelect,
    FanLogTableView,
    Card,
    BaseButton,
    BaseInput,
    BaseSwitch,
    BlipFileUploadZone,
    draggable,
    Collapse,
    CollapseItem,
    Cropper,
  },
  async created() {
    if (this.$route.query.unitId) {
      this.unitId = parseInt(this.$route.query.unitId);
    }
    await this.getScheduleTypes();
    await this.getScheduleMetadataTypes();
    await this.getCountryCodes();

    await this.getScheduleNotificationTypes();
    if (this.$route.query.scheduleId) {
      this.scheduleId = this.$route.query.scheduleId;
      await this.getSchedule();
    }
    await this.getMembers();
    await this.getAllUnits();
  },
  data() {
    return {
      buttonDisabled: false,
      unitId: null,
      scheduleId: null,
      parentScheduleId: null,
      scheduleType: "",
      scheduleTypes: [],
      scheduleMetadataType: null,
      scheduleMetadataTypes: [],
      countryCodes: [],
      cities: [],
      countryCode: null,
      city: null,
      scheduleNotificationTypes: {
        typeIds: [],
        options: [],
      },
      scheduleNotificationTimes: [],
      contentTypes: [
        { type: "I", name: "이미지" },
        { type: "V", name: "비디오" },
        { type: "T", name: "텍스트" },
      ],
      ratios: [
        { value: null, label: "원본" },
        { value: 1, label: "1:1" },
        { value: 2, label: "16:9" },
        { value: 3, label: "4:3" },
        { value: 4, label: "3:4" },
        { value: 5, label: "9:16" },
      ],
      ratioValues: [
        {
          key: 1,
          value: 1,
        },
        {
          key: 2,
          value: 1.78,
        },
        {
          key: 3,
          value: 1.33,
        },
        {
          key: 4,
          value: 0.75,
        },
        {
          key: 5,
          value: 0.56,
        },
      ],
      location: {
        type: null,
        options: [
          { label: "없음", value: null },
          { label: "장소", value: 1 },
          { label: "채널", value: 2 },
        ],
        name: null,
      },
      title: null,
      content: null,
      isSaveAll: false,
      isDeleted: false,
      repeat: {
        repeatId: null,
        repeatStartDate: null,
        repeatEndDate: null,
        options: [
          { label: "없음", value: null },
          { label: "매일", value: "d" },
          { label: "매주", value: "w" },
          { label: "매월", value: "m" },
          { label: "매년", value: "y" },
        ],
      },
      members: [],
      loadedMembers: [],
      contents: [],
      isImportant: false,
      isShow: true,
      isAllday: false,
      isEndTimeHidden: true,
      startTime: null,
      endTime: null,
      openTime: null,
      regTime: null,
      modTime: null,
      units: [],
    };
  },
  watch: {
    async countryCode(a, b) {
      await this.getCities();
    },
    isSaveAll() {
      if (!this.isSaveAll) {
        this.repeat.repeatId = null;
      }
    },
    scheduleType(newVal, oldVal) {
      if (oldVal === "" || newVal === oldVal) return;

      if (newVal && this.selectedScheduleMetadataTypes.length > 0) {
        this.scheduleMetadataType = null;
      }
    },
  },

  computed: {
    selectedScheduleMetadataType() {
      return this.scheduleMetadataTypes.find((item) => item.id === this.scheduleMetadataType) || {};
    },

    selectedScheduleMetadataTypes() {
      const data = this.scheduleMetadataTypes.filter((item) => item.scheduleType === parseInt(this.scheduleType, 10));
      if (data.length > 0) {
        return [{ id: null, name: "없음" }, ...data];
      }
      return [];
    },
  },

  methods: {
    async getAllUnits() {
      return this.$axios.get(`/artistUnit`).then((res) => {
        const data = res.data.data;
        this.units = data
          .filter((d) => d.unitId !== this.unitId)
          .map((d) => {
            d.value = false;
            return d;
          });
      });
    },
    addContent() {
      this.contents.push({ contentType: "I", ratio: null });
    },
    removeContent(index) {
      if (index !== -1) {
        this.contents.splice(index, 1);
      }
    },
    async onRatioChange(content) {
      if (content.ratio) {
        this.ratioValues.forEach((ratio) => {
          if (ratio.key === content.ratio) {
            content.aspectRatio = ratio.value;
          }
        });
      } else {
        await this.$axios.put(`/common/fileMetadata`, { fileId: content.imageFileId, extMetadata: null });
      }
    },
    onCropperChange(a, b) {
      console.log(a, b);
    },
    async cropImage(fileId, index) {
      const { coordinates } = this.$refs["cropper" + index][0].getResult();
      const display = { x: coordinates.left, y: coordinates.top, width: coordinates.width, height: coordinates.height };
      const extMetadata = { display };
      await this.$axios.put(`/common/fileMetadata`, { fileId, extMetadata });
      Toast.success("표시영역이 저장되었어요");
    },
    onChangeContentType(index) {
      const content = this.contents[index];
      if (content.extMetadata) {
        const extMetadata = JSON.parse(content.extMetadata);
        const me = this;
        if (content.contentType === "I") {
          setTimeout(function () {
            me.$refs["cropper" + index][0].setCoordinates(
              {
                width: extMetadata.display.width,
                height: extMetadata.display.height,
                left: extMetadata.display.x,
                top: extMetadata.display.y,
              },
              1000
            );
          });
        }
      }
    },
    onMediaFileIdChange(newFileIds, index) {
      this.contents[index].imageFileId = newFileIds[0];
      this.contents[index].imageUrl = window.Endpoints.imageServerUrl + newFileIds[0];
    },
    getMetadata(url, index) {
      if (url === "" || url === null) {
        Toast.error("url을 입력해주세요");
        return;
      }
      return this.$axios.get(`/common/metadata?url=${url}`).then((res) => {
        const data = res.data.data;
        this.contents[index].imageUrl = data.image;
        this.contents[index].imageFileId = null;
        this.contents[index].path = null;
        this.contents[index].path = url;
      });
    },
    async getSchedule() {
      return this.$axios.get(`/schedule/${this.scheduleId}`, { params: { unitId: this.unitId } }).then((res) => {
        const data = res.data.data;
        this.title = data.title;
        this.content = data.content;
        this.location.type = data.locationType;
        this.location.name = data.locationName;
        this.isAllday = data.isAllday === 1;
        this.isEndTimeHidden = data.isEndTimeHidden === 1;
        this.isImportant = data.isImportant === 1;
        this.isShow = data.isVisible === 1;
        this.isDeleted = data.isDeleted === 1;
        this.startTime = data.startTime;
        this.endTime = data.endTime;
        this.openTime = data.openTime;
        this.regTime = data.regTime;
        this.modTime = data.modTime;
        this.repeat.repeatId = data.periodUnit;
        this.repeat.repeatStartDate = data.repeatStartDate;
        this.repeat.repeatEndDate = data.repeatEndDate;
        this.scheduleNotificationTypes.typeIds = data.scheduleNotificationTypes;
        if (data.scheduleNotificationTimes) {
          this.scheduleNotificationTimes = data.scheduleNotificationTimes.map((time) => {
            return formatDateTime(time.notificationTime);
          });
        }
        this.scheduleType = data.type.toString();
        this.loadedMembers = data.members;
        this.parentScheduleId = data.parentScheduleId;
        this.scheduleMetadataType = data.metadataType;
        this.countryCode = data.countryCode;
        this.city = data.city;
        this.contents = data.contents;
        this.contents.map((content, index) => {
          if (content.imageFileId) {
            content.imageUrl = window.Endpoints.imageServerUrl + content.imageFileId;
          }
          if (content.ratio) {
            this.ratioValues.forEach((ratio) => {
              if (ratio.value === content.ratio) {
                content.ratio = ratio.key;
                content.aspectRatio = ratio.value;
              }
            });
          }
          if (content.extMetadata) {
            const extMetadata = JSON.parse(content.extMetadata);
            const me = this;
            if (content.contentType === "I") {
              setTimeout(function () {
                me.$refs["cropper" + index][0].setCoordinates(
                  {
                    width: extMetadata.display.width,
                    height: extMetadata.display.height,
                    left: extMetadata.display.x,
                    top: extMetadata.display.y,
                  },
                  1000
                );
              });
            }
          }
          return content;
        });

        if (data.periodUnit) {
          this.isSaveAll = true;
        }
        if (this.isDeleted) {
          Toast.error("삭제된 스케줄입니다");
        }
      });
    },
    async getScheduleTypes() {
      return this.$axios.get("/schedule/scheduleTypes").then((res) => {
        this.scheduleTypes = res.data.data;
      });
    },
    async getScheduleMetadataTypes() {
      return this.$axios.get("/schedule/getScheduleMetadataTypes").then((res) => {
        this.scheduleMetadataTypes = res.data.data;
      });
    },

    async getCountryCodes() {
      return this.$axios.get(`/common/countryCodes`).then((res) => {
        this.countryCodes = res.data.data;
      });
    },

    async getCities() {
      if (this.countryCode) {
        const country = this.countryCodes.find((countryCode) => countryCode.isoCode === this.countryCode);
        const countryId = country.id;
        return this.$axios.get(`/common/cities?countryId=${countryId}`).then((res) => {
          this.cities = res.data.data;
        });
      }
    },

    async getMembers() {
      return this.$axios.get(`/artistUnit/${this.unitId}/members`, null).then((res) => {
        const data = res.data.data;

        if (data.length > 0) {
          data
            .filter((item) => item.isVisible === 1)
            .forEach((item) => {
              const option = {};
              option.name = item.blipName ? item.blipName : item.name;
              option.id = item.artistId;
              option.value = false;
              if (this.loadedMembers.length > 0) {
                this.loadedMembers.forEach((m) => {
                  if (item.artistId === m) {
                    option.value = true;
                  }
                });
              }
              this.members.push(option);
            });
        }
      });
    },
    async getScheduleNotificationTypes() {
      return this.$axios.get("/schedule/scheduleNotificationTypes").then((res) => {
        const data = res.data.data;
        this.scheduleNotificationTypes.options = data.map((d) => {
          d.value = d.id;
          d.label = d.name;
          return d;
        });
      });
    },

    async searchCity() {
      if (this.city === "" || !this.city) {
        Toast.error("도시명을 입력해주세요");
        return;
      }

      return this.$axios.get(`/common/city?city=${this.city}`).then((res) => {
        console.log(res.data.data.candidates);
      });
    },

    applyTemplate(data) {
      const location = data.location;
      if (location === TemplateLocation.ADD) {
        if (this.content) {
          this.content += "\n" + data.contents;
        } else {
          this.content = data.contents;
        }
      } else if (location === TemplateLocation.OVERWRITE) {
        this.content = data.contents;
      } else if (location === TemplateLocation.BOTTOM) {
        if (this.contents.length === 0) {
          Toast.error("컨텐츠가 없어요");
        } else if (_.filter(this.contents, { contentType: "T" }).length === 0) {
          Toast.error("텍스트 타입 컨텐츠가 없어요");
        } else {
          if (_.last(_.filter(this.contents, { contentType: "T" })).description) {
            _.last(_.filter(this.contents, { contentType: "T" })).description += "\n" + data.contents;
          } else {
            _.last(_.filter(this.contents, { contentType: "T" })).description = data.contents;
          }
          this.isVisible = !this.isVisible;
          this.isVisible = !this.isVisible;
        }
      }
    },
    async sendNotification() {
      try {
        await this.$axios.put("/schedule/sendNotification", { scheduleId: this.scheduleId }).then((res) => {
          Toast.success(`알림이 전송되었습니다`);
        });
      } catch (e) {
        Toast.error("알림 발송 중 에러가 발생했습니다");
      }
    },

    async onSubmit() {
      if (!this.unitId) {
        Toast.error("잘못된 접근입니다");
        return;
      }
      if (this.scheduleType === "" || !this.scheduleType) {
        Toast.error("스케줄 타입을 지정해주세요 ");
        return;
      }
      if (this.title === "" || !this.title) {
        Toast.error("타이틀을 입력해주세요");
        return;
      }
      if (!this.startTime || !this.endTime) {
        Toast.error("스케줄 시간을 입력해주세요");
        return;
      }
      if (new Date(this.startTime) > new Date(this.endTime)) {
        Toast.error("종료시간이 시작시간보다 빨라요");
        return;
      }
      if (new Date(this.openTime) > new Date(this.startTime)) {
        Toast.error("예약노출시간이 시작시간보다 늦습니다");
        return;
      }
      if (this.repeat.repeatId) {
        if (!this.repeat.repeatStartDate || !this.repeat.repeatEndDate) {
          Toast.error("스케줄 반복기간을 지정해주세요 ");
          return;
        }
        if (new Date(this.repeat.repeatStartDate) > new Date(this.repeat.repeatEndDate)) {
          Toast.error("반복 종료시간이 시작시간보다 빨라요");
          return;
        }
      }
      if (this.contents?.length > 0) {
        const contents = this.contents;
        for (let i = 0; i < contents.length; i++) {
          const content = contents[i];
          if (content.contentType === "I") {
            if (!content.imageFileId && !content.imageUrl) {
              Toast.error("컨텐츠 이미지를 등록해주세요");
              return;
            }
          } else if (content.contentType === "V") {
            if (!content.imageFileId && !content.imageUrl) {
              Toast.error("컨텐츠 이미지를 등록해주세요");
              return;
            }
            if (!content.path) {
              Toast.error("컨텐츠 URL을 등록해주세요");
              return;
            }
          } else if (content.contentType === "T") {
            if (!content.description || content.description === "") {
              Toast.error("컨텐츠 텍스트를 등록해주세요");
              return;
            }
          }
        }
      }

      const param = {};
      if (this.isAllday) {
        this.startTime = moment(this.startTime).hours(0).minutes(0).toISOString();
        this.endTime = moment(this.endTime).hours(0).minutes(0).toISOString();
      }
      param.type = this.scheduleType;
      param.scheduleNotificationTypes = [];
      if (this.scheduleMetadataType && this.selectedScheduleMetadataTypes.length > 0) {
        param.metadata = {
          scheduleMetadataType: this.scheduleMetadataType,
          countryCode: this.countryCode,
          city: this.city,
        };
      }
      if (this.scheduleNotificationTypes.typeIds?.length > 0) {
        this.scheduleNotificationTypes.typeIds.forEach((typeId) => {
          this.scheduleNotificationTypes.options.forEach((type) => {
            if (typeId === type.id) {
              // 시작시간 기준
              if (type.timeStandard === 1) {
                param.scheduleNotificationTypes.push({
                  notificationType: type.id,
                  notificationTime: moment(this.startTime).add(type.timeInterval, "minutes").second(0),
                });
              }
              // 종료시간 기준
              else if (type.timeStandard === 2) {
                param.scheduleNotificationTypes.push({
                  notificationType: type.id,
                  notificationTime: moment(this.endTime).add(type.timeInterval, "minutes").second(0),
                });
              }
            }
          });
        });
      }
      param.title = this.title;
      param.content = this.content;
      param.contents = this.contents.map((content) => {
        if (content.ratio) {
          this.ratioValues.forEach((ratio) => {
            if (ratio.key === content.ratio) {
              content.ratio = ratio.value;
            }
          });
        }
        return content;
      });
      if (this.location.type) {
        param.locationType = this.location.type;
        param.locationName = this.location.name;
      } else {
        param.locationType = null;
        param.locationName = null;
      }
      param.members = [];
      this.members.forEach((m) => {
        if (m.id !== "") {
          if (m.value) {
            param.members.push(m.id);
          }
        }
      });
      param.isShow = this.isShow ? 1 : 0;
      param.isImportant = this.isImportant ? 1 : 0;
      param.isAllday = this.isAllday ? 1 : 0;
      param.isEndTimeHidden = this.isEndTimeHidden ? 1 : 0;
      param.startTime = this.startTime;
      param.endTime = this.endTime;
      param.openTime = this.openTime;
      if (this.repeat.repeatId) {
        if (this.repeatStartDate < this.repeatStartDate) {
          Toast.error("반복종료가 반복시작보다 빨라요 ");
          return;
        }
        param.periodUnit = this.repeat.repeatId;
        param.repeatStartDate = this.repeat.repeatStartDate;
        param.repeatEndDate = this.repeat.repeatEndDate;
      }
      if (!this.scheduleId) {
        this.buttonDisabled = true;
        param.units = [];
        this.units.forEach((u) => {
          if (u.value) {
            param.units.push(u.unitId);
          }
        });
        return this.$axios.post(`/schedule/${this.unitId}`, { param }).then((res) => {
          Toast.success("등록되었습니다");
          history.go(-1);
        });
      } else {
        param.scheduleId = this.scheduleId;
        if (this.isSaveAll) {
          if (this.parentScheduleId) {
            param.scheduleId = this.parentScheduleId;
          }
        }
        param.isSaveAll = this.isSaveAll;
        if (!this.repeat.repeatId) {
          param.isSaveAll = false;
        }
        return this.$axios.put(`/schedule/${this.unitId}`, { param }).then((res) => {
          Toast.success("수정되었습니다");
          history.go(-1);
        });
      }
    },

    deleteSchedule() {
      if (!this.unitId || !this.scheduleId) {
        Toast.error("잘못된 접근입니다");
        return;
      }
      const param = {};
      param.scheduleId = this.scheduleId;
      return this.$axios.post(`/schedule/${this.unitId}/delete`, { param }).then((res) => {
        Toast.success("삭제되었습니다");
        history.go(-1);
      });
    },

    deleteAllSchedule() {
      if (!this.unitId || !this.scheduleId) {
        Toast.error("잘못된 접근입니다");
        return;
      }
      const param = {};
      param.scheduleId = this.scheduleId;
      if (this.parentScheduleId) {
        param.parentScheduleId = this.parentScheduleId;
      }
      return this.$axios.post(`/schedule/${this.unitId}/delete`, { param }).then((res) => {
        Toast.success("삭제되었습니다");
        history.go(-1);
      });
    },

    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style>
.bootstrap-switch {
  margin: 6px;
}
textarea.form-control {
  max-height: 150px;
}
</style>
